// InfoCard.js
import React from 'react';
import './CardLayout.css';


const formatTimeFriendly = (time24) => {
    // Validate input format: must be HH:MM
    if (typeof time24 !== 'string') {
        return '';
    }

    const [hourStr, minuteStr] = time24.split(':');
    const hour = parseInt(hourStr, 10);
    const minute = parseInt(minuteStr, 10);

    // Validate hour and minute ranges
    if (isNaN(hour) || isNaN(minute) || hour < 0 || hour > 23 || minute < 0 || minute > 59) {
        return '';
    }

    const ampm = hour >= 12 ? 'PM' : 'AM';
    const hour12 = hour % 12 || 12;
    const paddedMinute = String(minute).padStart(2, '0');

    return `${hour12}:${paddedMinute} ${ampm}`;
}

const formatDate = (dateObj) => {
    const date = new Date(dateObj + 'T12:00:00-06:00');

    const shortFriendly = date?.toLocaleDateString('en-US', {
        year: 'numeric',
        month: 'short',
        day: 'numeric'
    });

    if (shortFriendly === 'Invalid Date') {
        return '';
    }
    return shortFriendly;
}



const InfoCard = ({ item }) => {


    var date = formatDate(item?.EventStartDate);
    var start = formatTimeFriendly(item?.EventStartTime);
    var end = formatTimeFriendly(item?.EventEndTime);

   

    return (
        <div className="InfoCard2">
            <h5>{item?.EventName}</h5>
            <p>{item?.EventFormattedAddress ?? ''}</p>
            <p style={{ fontWeight: 'bold', margin: 0 }}>
                {date} {start}{end ? ` - ${end}` : ''}
            </p>
        </div>
    );
};

export default InfoCard;
